define(function(require, exports, module) {
    'use strict';

    const core = require('core');
    const { dispatcher } = require('bundle');

    dispatcher.listen('user:details:kir', function(data) {
        core.trigger('user:details:kir', data);
    });

    dispatcher.listen('user:details:mobywatel-total-casino', function(data) {
        core.trigger('user:details:mobywatel-total-casino', data);
    });

    dispatcher.listen('registration:beforeClose', function() {
        core.trigger('registration:beforeClose');
    });

    core.listenTo(core, 'regLoginLimits:validate', (handler) => {
        dispatcher.dispatch('regLoginLimits:validate', handler);
    });

    core.listenTo(core, 'user:toggleInboxInNavigation', (data) => {
        dispatcher.dispatch('user:toggleInboxInNavigation', data);
    });

    /* TotalCasino changes config for promocode event */
    core.listenTo(core, 'promocode:success', (data) => {
        dispatcher.dispatch('promocode:success', data);
    });

    core.listenTo(core, 'registration:rendered', (data) => {
        dispatcher.dispatch('registration:rendered', data);
    });

    module.exports = core;
});
